import { defineStore } from 'pinia';
import { ref } from 'vue';
import type {
  MasterRule,
  MasterRuleUpdateRequest,
  ResultOfOkOfMasterRuleAndNotFound,
} from '@/api/client/models/index.ts';
import { useApiClient } from '@/hooks/api-hook.ts';

type LegacyMasterRulePayload = Partial<MasterRule> & Record<string, unknown>;

function normalizeMasterRuleResponse(response: ResultOfOkOfMasterRuleAndNotFound | undefined): MasterRule[] {
  const rule = response?.value?.value;

  if (response?.isOk !== true || response.isFailure || !rule) {
    throw new Error('Master business rule could not be loaded.');
  }

  return [rule];
}

export const useMasterRulesStore = defineStore('masterRules', () => {
  const apiClient = useApiClient();

  const list = ref<MasterRule[]>([]);
  const loading = ref<boolean>(true);

  async function update(data: LegacyMasterRulePayload): Promise<ArrayBuffer | undefined> {
    return await apiClient.masterRule.put(data as MasterRuleUpdateRequest);
  }

  async function get({ showOnlyActive }: { showOnlyActive?: boolean } = {}): Promise<MasterRule[]> {
    void showOnlyActive;
    loading.value = true;

    try {
      const response = await apiClient.masterRule.get();
      list.value = normalizeMasterRuleResponse(response);
      return list.value;
    } finally {
      loading.value = false;
    }
  }

  return {
    list,
    loading,
    update,
    get,
  };
});
